<template>
  <div
    class="team-decoration-box"
    :class="{ editable: decorationEditable }"
    @click="toggleEditDecoration"
  >
    <div
      class="team-decoration-box-img-wrapper"
      v-if="typeOfDecoration === 'team uniform'"
    >
      <img class="team-decoration-box-img" :src="imgThumbnail" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "TeamDecorationBox",
  computed: {
    ...mapState("threekit", ["spiritwearThumbnail", "uniformThumbnail"]),
    ...mapGetters("project", [
      "spiritwearCustomGraphic",
      "uniformCustomGraphic",
    ]),
    ...mapGetters("uploadLogos", ["editableLogo"]),

    decorationEditable() {
      //only edit if not using a custom logo
      return this.typeOfDecoration === "spiritwear"
        ? this.spiritwearCustomGraphic === null || !this.finalStep
        : this.uniformCustomGraphic === null || !this.finalStep;
    },

    hasLogo() {
      return this.editableLogo && this.editableLogo.content;
    },

    imgThumbnail() {
      return this.hasLogo ? this.editableLogo.content : this.uniformThumbnail;
    },
  },
  methods: {
    ...mapActions("showroom", ["setCustomizationStep"]),

    toggleEditDecoration() {
      if (this.decorationEditable) {
        if (!this.finalStep) {
          const nextStep = `${this.typeOfDecoration}-decorations`;
          this.setCustomizationStep(nextStep.replace("team ", ""));
        } else {
          if (!this.hasLogo) {
            this.$emit("clickDecoration");
          }
          else {
            this.$emit("nextLogoStep")
          }
        }
      }
    },
  },
  props: {
    typeOfDecoration: {
      type: String, //team uniform / spiritwear
    },
    finalStep: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  .team-decoration-box {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px;
    background: #f9fafa;
    border: 1px solid #bcc2c8;
    box-sizing: border-box;
    border-radius: 6px;
    width: 322px;
    height: 78px;
    margin: 0 auto;
    &.editable {
      cursor: pointer;
      &:hover {
        border: 1px solid $dark;
      }
    }

    .team-decoration-box-img-wrapper {
      height: 100%;
      padding: 0 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .team-decoration-box-img {
        /*max-width: 100%;*/
        max-height: 100%;
        margin: 3px;
      }
    }
  }
}
</style>